import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './AtivarConta.module.css';
import Input from '../shared/form/Input';

function AtivarConta() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    verificarToken();
  }, []);

  const verificarToken = async () => {
    if (!token) {
      setErro('Token de ativação não encontrado');
      setLoading(false);
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/verificar-token/${token}`);
      const data = await response.json();

      if (response.ok) {
        setNome(data.funcionario.nome);
        setEmail(data.funcionario.email);
        setLoading(false);
      } else {
        setErro(data.error || 'Token inválido');
        setLoading(false);
      }
    } catch (error) {
      console.error('Erro ao verificar token:', error);
      setErro('Erro ao verificar token. Tente novamente.');
      setLoading(false);
    }
  };

  const handleAtivarConta = async (e) => {
    e.preventDefault();
    setErro('');

    // Validações
    if (!senha || !confirmarSenha) {
      setErro('Por favor, preencha todos os campos');
      return;
    }

    if (senha.length < 6) {
      setErro('A senha deve ter no mínimo 6 caracteres');
      return;
    }

    if (senha !== confirmarSenha) {
      setErro('As senhas não coincidem');
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/ativar-conta`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token, senha })
      });

      const data = await response.json();

      if (response.ok) {
        setSucesso(true);
        setTimeout(() => {
          navigate('/home');
        }, 3000);
      } else {
        setErro(data.error || 'Erro ao ativar conta');
      }
    } catch (error) {
      console.error('Erro ao ativar conta:', error);
      setErro('Erro ao ativar conta. Tente novamente.');
    }
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.loading}>
            <p>Verificando token...</p>
          </div>
        </div>
      </div>
    );
  }

  if (erro && !nome) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.erro}>
            <h2>Erro</h2>
            <p>{erro}</p>
            <button onClick={() => navigate('/login')} className={styles.btn}>
              Ir para Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (sucesso) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.sucesso}>
            <h2>Conta Ativada com Sucesso!</h2>
            <p>Você será redirecionado para a página de login...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h1>Ative sua Conta</h1>
          <p className={styles.bemvindo}>Bem-vindo, {nome}!</p>
          <p className={styles.subtitulo}>
            Crie sua senha para acessar o sistema SpeedOrder
          </p>
        </div>

        <form onSubmit={handleAtivarConta} className={styles.form}>
          <div className={styles.infoUsuario}>
            <p><strong>Email:</strong> {email}</p>
          </div>

          <Input
            type="password"
            text="Senha"
            name="senha"
            placeholder="Digite sua senha (mínimo 6 caracteres)"
            value={senha}
            handleOnChange={(e) => setSenha(e.target.value)}
          />

          <Input
            type="password"
            text="Confirmar Senha"
            name="confirmarSenha"
            placeholder="Digite sua senha novamente"
            value={confirmarSenha}
            handleOnChange={(e) => setConfirmarSenha(e.target.value)}
          />

          {erro && <p className={styles.mensagemErro}>{erro}</p>}

          <button type="submit" className={styles.btn}>
            Ativar Conta
          </button>
        </form>
      </div>
    </div>
  );
}

export default AtivarConta;
